import { XStack, Button, SizableText, XStackProps } from '@my/ui'
import { ChevronLeft, X } from '@tamagui/lucide-icons'

type GroupCreationHeaderProps = {
  onBack?: () => void
  onClose?: () => void
  title: string
  children?: React.ReactNode
}

export const GroupCreationHeader = ({
  onClose,
  onBack,
  title,
  children,
  ...props
}: GroupCreationHeaderProps & XStackProps) => {
  return (
    <XStack gap="$2" py="$2" bg="$white" {...props}>
      <XStack ai="center" gap="$2">
        {onClose && (
          <Button
            ml="auto"
            aria-label="Close"
            plain
            size="$3"
            icon={<X size={24} />}
            px="$2"
            onPress={onClose}
          />
        )}
        {onBack && (
          <Button
            ml="auto"
            aria-label="Close"
            plain
            size="$3"
            icon={<ChevronLeft size={24} />}
            px="$2"
            onPress={onBack}
          />
        )}
        <SizableText
          size="$3"
          fow="500"
          $gtXs={{
            size: '$5',
            fow: '500',
          }}
        >
          {title}
        </SizableText>
      </XStack>
      {children && (
        <XStack gap="$2" ml="auto">
          {children}
        </XStack>
      )}
    </XStack>
  )
}
